import { Action } from 'redux';
import { ContextEnum, PlayerStatus } from '../entities';

export enum TPlayer {
  PLAY = 'PLAY',
  PAUSE = 'PAUSE',
  NEXT = 'NEXT',
  SET_PLAYER_STATUS = 'SET_PLAYER_STATUS',
  PLAY_FROM = 'PLAY_FROM',
  PLAY_FROM_MEDIA = 'PLAY_FROM_MEDIA',
  PLAY_FROM_SLOT = 'PLAY_FROM_SLOT',
  PLAY_FROM_PLAYLIST = 'PLAY_FROM_PLAYLIST',
  PLAY_FROM_FAVORITE = 'PLAY_FROM_FAVORITE',
  PLAY_FROM_TEMPO = 'PLAY_FROM_TEMPO',
  PLAY_FROM_SCHEDULE_24 = 'PLAY_FROM_SCHEDULE_24',
  PLAY_FROM_SCHEDULE_WEEK = 'PLAY_FROM_SCHEDULE_WEEK',
  SET_VOLUME = 'SET_VOLUME',
  VOLUME_UP = 'VOLUME_UP',
  VOLUME_DOWN = 'VOLUME_DOWN',
  SHUFFLE = 'SHUFFLE',
  PING = 'PING',
  SYNC = 'SYNC'
}

export interface ISetPlayer extends Action {
  type: TPlayer.SET_PLAYER_STATUS;
  payload: PlayerStatus;
}
export const ASetPlayer = (payload: Partial<PlayerStatus>): ISetPlayer => ({ type: TPlayer.SET_PLAYER_STATUS, payload });

export interface ISlideVolume extends Action {
  type: TPlayer.SET_VOLUME;
  payload: number;
}

export const ASlideVolume = (payload: number): { volume: number; type: TPlayer.SET_VOLUME } =>
  ({ type: TPlayer.SET_VOLUME, volume: payload });

export interface ISetVolume extends Action {
  type: string;
}
export const ASetVolume = (type: string): ISetVolume => ({ type });


export interface IPing extends Action {
  type: TPlayer.PING;
}

export const APing = (): IPing => ({ type: TPlayer.PING });


export interface IPlay extends Action {
  type: TPlayer.PLAY;
}
export const APlay = (): IPlay => ({ type: TPlayer.PLAY });

export interface IPause extends Action {
  type: TPlayer.PAUSE;
}
export const APause = (): IPause => ({ type: TPlayer.PAUSE });

export interface IShuffle extends Action {
  type: TPlayer.SHUFFLE;
}
export const AShuffle = (): IShuffle => ({ type: TPlayer.SHUFFLE });

export interface INext extends Action {
  type: TPlayer.NEXT;
}
export const ANext = (): INext => ({ type: TPlayer.NEXT });

export interface IPlayFrom extends Action {
  type: TPlayer.PLAY_FROM;
  payload: PlayerStatus;
}

interface IPlayFromMediaPayload {
  type: TPlayer.PLAY_FROM;
  media: { id: string };
  event?: { id: string };
  tempo?: { id: string};
  player: { id: string };
  playerContextType?: string;
  id?: string;
  shuffle?: boolean;
}

export interface IPlayFromMedia extends Action {
  type: TPlayer.PLAY_FROM_MEDIA;
}
export const APlayFromMedia = (payload: IPlayFromMediaPayload): IPlayFromMediaPayload =>
  ({
    media: payload.media,
    event: payload.event,
    tempo: payload.tempo,
    playerContextType: payload.playerContextType,
    id: payload.id,
    player: payload.player,
    type: payload.type,
    shuffle: payload.shuffle
  });


export interface IPlayFromSlot extends Action {
  type: TPlayer.PLAY_FROM_SLOT;
  payload: { id: string };
}
export const APlayFromSlot = (payload: {id: string}): IPlayFrom =>
  ({ type: TPlayer.PLAY_FROM, payload: { ...payload, context: ContextEnum.timeSlot, location: 'scheduler' } });
interface IPlayFromFavoritePayload {
  favorite: {
    id: string
  };
  playerContextType: string;
  favoriteDurationTime: number;
}
export interface IPlayFromFavorite extends Action {
  type: TPlayer.PLAY_FROM_FAVORITE;
  payload: IPlayFromFavoritePayload;
}
export const APlayFromFavorite = (payload: IPlayFromFavoritePayload) => ({ type: TPlayer.PLAY_FROM, ...payload });

export interface IPlayFromPlaylist extends Action {
  type: TPlayer.PLAY_FROM_PLAYLIST;
}
export const APlayFromPlaylist = (payload: any) => ({ type: TPlayer.PLAY_FROM, ...payload });

export const APlayFromSchedule24 = (payload: any) => ({ type: TPlayer.PLAY_FROM, ...payload });

export const APlayFromScheduleWeek = (payload: any) => ({ type: TPlayer.PLAY_FROM, ...payload });


export interface IPlayFromTempo extends Action {
  type: TPlayer.PLAY_FROM_TEMPO;
  payload: {id: string};
}
export const APlayFromTempo = (payload: { id: string }): IPlayFrom =>
  ({ type: TPlayer.PLAY_FROM, payload: { ...payload, context: ContextEnum.tempo, location: `tempos/${payload.id}` } });


export interface IAsync extends Action {
  type: TPlayer.SYNC;
}
export const ASync = () => ({ type: TPlayer.SYNC });
